<template>
  <v-app>
    <v-content>
      <v-container grid-list-sm fluid pa-0>
        <v-layout row wrap justify-center>
          <v-flex xs12 style="height: 120px;" class="primary elevation-2 hidden-print-only">
            <v-btn large class="mx-3" @click="$router.back()" icon dark>
              <v-icon medium>mdi-arrow-left</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12 sm10 md8 class="printable rt-5">
            <router-view class="pointer-event-auto" />
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  beforeDestroy() {
    // this.$store.commit("app/clearReports");
  }
};
</script>
<style>
.store-logo {
  height: 80px;
  width: auto;
}
@media screen {
  .printable {
    border-radius: 4px;
    background-color: white;
    box-shadow: 0px 0px 40px 0px rgb(0, 0, 0, 0.02);
  }
}
</style>

